<template>
    <div
        v-if="src && isSuccess"
        class="lazy-image"
        :class="[radius && 'radius', modal && 'clickable', absolute && 'absolute']">
        <img
            :src="src"
            :alt="alt"
            @click="toggleModal"
            @error="onImageError"
            loading="lazy" />

        <Modal
            v-if="open"
            :title="title"
            :onClose="toggleModal"
            scroll="box"
            padding="s"
            size="xl">
            <img :src="src" :alt="alt" loading="lazy" class="modal-image" />
        </Modal>
    </div>
</template>

<script lang="ts">
    import { defineComponent, ref } from 'vue';
    import Modal from '@ui/components/Modal/Modal.vue';

    export default defineComponent({
        name: 'LazyImage',
        components: { Modal },
        props: {
            src: String,
            title: String,
            absolute: Boolean,
            alt: {
                type: String,
                required: true,
            },
            modal: {
                type: Boolean,
                default: false,
            },
            radius: {
                type: Boolean,
                default: false,
            },
        },
        setup(props) {
            const open = ref<boolean>(false);
            const isSuccess = ref<boolean>(true);

            const toggleModal = () => {
                if (props.modal) {
                    open.value = !open.value;
                }
            };

            const onImageError = () => {
                isSuccess.value = false;
            };

            return {
                open,
                isSuccess,
                toggleModal,
                onImageError,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './LazyImage.scss';
</style>
